import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const CardBigNumberTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Geist Mono, monospaced',
  fontSize: theme.typography.pxToRem(64),
  textAlign: 'center',
  textEdge: 'cap',
  fontWeight: 300,
  fontStyle: 'normal',
  lineHeight: 1,
  textTransform: 'uppercase'
}))
